// extracted by css-extract-rspack-plugin
export default {"dotSeparated":"kAaGg"};